import apiFetch from '../apiFetch'

export default function (saleId, comment, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/sale/${saleId}/reject`, method: 'PUT', body: comment, token: token, lastAccessDate })
}
